module.exports = __webpack_public_path__ + "img/14.3b0ab077.jpg";